export default "__VITE_ASSET__BgUhqfvk__";